export class GetAuditLogs {
    constructor(auditLogRepository) {
      this.auditLogRepository = auditLogRepository;
    }
  
    async execute(getUserLogsRequest) {
        console.log("audit Log Repository", getUserLogsRequest)
      return await this.auditLogRepository.getAuditLogs(getUserLogsRequest);
    }
  }